export const GET_DELIVERED_IDS_REQUEST = 'GET_DELIVERED_IDS_REQUEST';
export const GET_DELIVERED_IDS_SUCCESS = 'GET_DELIVERED_IDS_SUCCESS';
export const GET_DELIVERED_IDS_FAILED = 'GET_DELIVERED_IDS_FAILED';
export const GET_DELIVERED_IDS_CLEAR = 'GET_DELIVERED_IDS_CLEAR';

export const GET_LAST_DOMAIN_SIGHTINGS_REQUEST =
  'GET_LAST_DOMAIN_SIGHTINGS_REQUEST';
export const GET_LAST_DOMAIN_SIGHTINGS_SUCCESS =
  'GET_LAST_DOMAIN_SIGHTINGS_SUCCESS';
export const GET_LAST_DOMAIN_SIGHTINGS_FAILED =
  'GET_LAST_DOMAIN_SIGHTINGS_FAILED';
export const GET_LAST_DOMAIN_SIGHTINGS_CLEAR =
  'GET_LAST_DOMAIN_SIGHTINGS_CLEAR';

export const GET_FIRST_DOMAIN_SIGHTINGS_REQUEST =
  'GET_FIRST_DOMAIN_SIGHTINGS_REQUEST';
export const GET_FIRST_DOMAIN_SIGHTINGS_SUCCESS =
  'GET_FIRST_DOMAIN_SIGHTINGS_SUCCESS';
export const GET_FIRST_DOMAIN_SIGHTINGS_FAILED =
  'GET_FIRST_DOMAIN_SIGHTINGS_FAILED';
export const GET_FIRST_DOMAIN_SIGHTINGS_CLEAR =
  'GET_FIRST_DOMAIN_SIGHTINGS_CLEAR';

export const GET_RESERVE_DOMAIN_PENDING_REQUEST =
  'GET_RESERVE_DOMAIN_PENDING_REQUEST';
export const GET_RESERVE_DOMAIN_PENDING_SUCCESS =
  'GET_RESERVE_DOMAIN_PENDING_SUCCESS';
export const GET_RESERVE_DOMAIN_PENDING_FAILED =
  'GET_RESERVE_DOMAIN_PENDING_FAILED';
export const GET_RESERVE_DOMAIN_PENDING_CLEAR =
  'GET_RESERVE_DOMAIN_PENDING_CLEAR';

export const GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_REQUEST =
  'GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_REQUEST';
export const GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_SUCCESS =
  'GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_SUCCESS';
export const GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_FAILED =
  'GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_FAILED';
export const GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_CLEAR =
  'GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_CLEAR';

export const GET_DOMAINS_IMAGES_STATUSES_IDS_REQUEST =
  'GET_DOMAINS_IMAGES_STATUSES_IDS_REQUEST';
export const GET_DOMAINS_IMAGES_STATUSES_IDS_SUCCESS =
  'GET_DOMAINS_IMAGES_STATUSES_IDS_SUCCESS';
export const GET_DOMAINS_IMAGES_STATUSES_IDS_FAILED =
  'GET_DOMAINS_IMAGES_STATUSES_IDS_FAILED';
export const GET_DOMAINS_IMAGES_STATUSES_IDS_CLEAR =
  'GET_DOMAINS_IMAGES_STATUSES_IDS_CLEAR';

export const FILTER_SIGHTINGS_REQUEST = 'FILTER_SIGHTINGS_REQUEST';
export const FILTER_SIGHTINGS_SUCCESS = 'FILTER_SIGHTINGS_SUCCESS';
export const FILTER_SIGHTINGS_FAILED = 'FILTER_SIGHTINGS_FAILED';

export const UPDATE_IMAGE_STATUS_REQUEST = 'UPDATE_IMAGE_STATUS_REQUEST';
export const UPDATE_IMAGE_STATUS_SUCCESS = 'UPDATE_IMAGE_STATUS_SUCCESS';
export const UPDATE_IMAGE_STATUS_FAILED = 'UPDATE_IMAGE_STATUS_FAILED';
export const UPDATE_IMAGE_STATUS_CLEAR = 'UPDATE_IMAGE_STATUS_CLEAR';

export const SET_RETURNED_FOR_COMMENT_TRUE_REQUEST =
  'SET_RETURNED_FOR_COMMENT_TRUE_REQUEST';
export const SET_RETURNED_FOR_COMMENT_TRUE_SUCCESS =
  'SET_RETURNED_FOR_COMMENT_TRUE_SUCCESS';
export const SET_RETURNED_FOR_COMMENT_TRUE_FAILED =
  'SET_RETURNED_FOR_COMMENT_TRUE_FAILED';
export const SET_RETURNED_FOR_COMMENT_TRUE_CLEAR =
  'SET_RETURNED_FOR_COMMENT_TRUE_CLEAR';

export const UPDATE_IMAGES_DATA_REQUEST = 'UPDATE_IMAGES_DATA_REQUEST';
export const UPDATE_IMAGES_DATA_SUCCESS = 'UPDATE_IMAGES_DATA_SUCCESS';
export const UPDATE_IMAGES_DATA_FAILED = 'UPDATE_IMAGES_DATA_FAILED';
export const UPDATE_IMAGES_DATA_CLEAR = 'UPDATE_IMAGES_DATA_CLEAR';

export const SET_RETURNED_FOR_REVIEW_DATA_REQUEST =
  'SET_RETURNED_FOR_REVIEW_DATA_REQUEST';
export const SET_RETURNED_FOR_REVIEW_DATA_SUCCESS =
  'SET_RETURNED_FOR_REVIEW_DATA_SUCCESS';
export const SET_RETURNED_FOR_REVIEW_DATA_FAILED =
  'SET_RETURNED_FOR_REVIEW_DATA_FAILED';
export const SET_RETURNED_FOR_REVIEW_DATA_CLEAR =
  'SET_RETURNED_FOR_REVIEW_DATA_CLEAR';

export const UPDATE_HOLD_DOMAIN_DATA_REQUEST =
  'UPDATE_HOLD_DOMAIN_DATA_REQUEST';
export const UPDATE_HOLD_DOMAIN_DATA_SUCCESS =
  'UPDATE_HOLD_DOMAIN_DATA_SUCCESS';
export const UPDATE_HOLD_DOMAIN_DATA_FAILED = 'UPDATE_HOLD_DOMAIN_DATA_FAILED';
export const UPDATE_HOLD_DOMAIN_DATA_CLEAR = 'UPDATE_HOLD_DOMAIN_DATA_CLEAR';

export const UPDATE_HOLD_IMAGE_DATA_REQUEST = 'UPDATE_HOLD_IMAGE_DATA_REQUEST';
export const UPDATE_HOLD_IMAGE_DATA_SUCCESS = 'UPDATE_HOLD_IMAGE_DATA_SUCCESS';
export const UPDATE_HOLD_IMAGE_DATA_FAILED = 'UPDATE_HOLD_IMAGE_DATA_FAILED';
export const UPDATE_HOLD_IMAGE_DATA_CLEAR = 'UPDATE_HOLD_IMAGE_DATA_CLEAR';

export const DELETE_HOLD_DOMAIN_DATA_REQUEST =
  'DELETE_HOLD_DOMAIN_DATA_REQUEST';
export const DELETE_HOLD_DOMAIN_DATA_SUCCESS =
  'DELETE_HOLD_DOMAIN_DATA_SUCCESS';
export const DELETE_HOLD_DOMAIN_DATA_FAILED = 'DELETE_HOLD_DOMAIN_DATA_FAILED';
export const DELETE_HOLD_DOMAIN_DATA_CLEAR = 'DELETE_HOLD_DOMAIN_DATA_CLEAR';

export const CHANGE_DOMAIN_REVIEW_IMAGES_DATA =
  'CHANGE_DOMAIN_REVIEW_IMAGES_DATA';
export const CHANGE_DOMAIN_DATA = 'CHANGE_DOMAIN_DATA';
export const CLEAR_DOMAIN_REVIEW_IMAGES_DATA =
  'CLEAR_DOMAIN_REVIEW_IMAGES_DATA';
export const ADD_TO_DELIVERED = 'ADD_TO_DELIVERED';
export const CLEAR_ADD_TO_DELIVERED = 'CLEAR_ADD_TO_DELIVERED';

export const GET_DOWNLOADED_IMAGE_DATA_REQUEST =
  'GET_DOWNLOADED_IMAGE_DATA_REQUEST';
export const GET_DOWNLOADED_IMAGE_DATA_SUCCESS =
  'GET_DOWNLOADED_IMAGE_DATA_SUCCESS';
export const GET_DOWNLOADED_IMAGE_DATA_FAILED =
  'GET_DOWNLOADED_IMAGE_DATA_FAILED';
export const GET_DOWNLOADED_IMAGE_DATA_CLEAR =
  'GET_DOWNLOADED_IMAGE_DATA_CLEAR';

export const SAVE_DOMAIN_DATA_AS_REVIEW_REQUEST =
  'SAVE_DOMAIN_DATA_AS_REVIEW_REQUEST';
export const SAVE_DOMAIN_DATA_AS_REVIEW_SUCCESS =
  'SAVE_DOMAIN_DATA_AS_REVIEW_SUCCESS';
export const SAVE_DOMAIN_DATA_AS_REVIEW_FAILED =
  'SAVE_DOMAIN_DATA_AS_REVIEW_FAILED';
export const SAVE_DOMAIN_DATA_AS_REVIEW_CLEAR =
  'SAVE_DOMAIN_DATA_AS_REVIEW_CLEAR';

export const CLEAR_DOMAINS_SELECTED_FILTER_DATA =
  'CLEAR_DOMAINS_SELECTED_FILTER_DATA';

export const SEND_UPDATED_IMAGE_URL_REQUEST = 'SEND_UPDATED_IMAGE_URL_REQUEST';
export const SEND_UPDATED_IMAGE_URL_SUCCESS = 'SEND_UPDATED_IMAGE_URL_SUCCESS';
export const SEND_UPDATED_IMAGE_URL_FAILED = 'SEND_UPDATED_IMAGE_URL_FAILED';

export const GET_SIGHTINGS_INFO_REQUEST = 'GET_SIGHTINGS_INFO_REQUEST';
export const GET_SIGHTINGS_INFO_SUCCESS = 'GET_SIGHTINGS_INFO_SUCCESS';
export const GET_SIGHTINGS_INFO_FAILED = 'GET_SIGHTINGS_INFO_FAILED';

export const PARK_DOMAIN_REQUEST = 'PARK_DOMAIN_REQUEST';
export const PARK_DOMAIN_SUCCESS = 'PARK_DOMAIN_SUCCESS';
export const PARK_DOMAIN_FAILED = 'PARK_DOMAIN_FAILED';

export const GET_FB_IMAGE_URL_REQUEST = 'GET_FB_IMAGE_URL_REQUEST';
export const GET_FB_IMAGE_URL_SUCCESS = 'GET_FB_IMAGE_URL_SUCCESS';
export const GET_FB_IMAGE_URL_FAILED = 'GET_FB_IMAGE_URL_FAILED';
